import { usePrevious } from 'hooks';
import { useContext, useEffect, useState } from 'react';
import { FlagContext } from './FeatureFlagProvider';

const useFeatureFlag = ({ flag = '', newFlag = false }) => {
  const [enabled, setEnabled] = useState(false);
  const { checkFlag, setNewFlag } = useContext(FlagContext);
  const prevFlag = usePrevious(flag);

  useEffect(() => {
    setEnabled(checkFlag(flag));
  }, [checkFlag, flag, newFlag, prevFlag, setNewFlag]);

  const setFlag = flag => {
    setNewFlag(flag, true);
    setEnabled(true);
  };

  return [enabled, setFlag];
};

export default useFeatureFlag;
